import { useGetDispatchPlaceHistory } from '@/features/dispatch-places/dispatch-places.queries';

export const useHistorySection = (dp_id: string) => {
  const { data, isLoading, isError } = useGetDispatchPlaceHistory(dp_id);

  return {
    items: data?.items ?? [],
    isLoading,
    isError,
  };
};
